import Request from './request';
import { stringify } from "qs";
import { EducationModifyProps, EducationProps } from "../pages/types";

function getBase() {
    if (window.location.hostname.search('tibavip') !== -1) {
        return '/api'
    }
    return '/api/customer'
}

// const base = Api_base.base_url
const base = getBase()
// const base = '/api/customer'

interface PropName {
    [propName: string]: any
}

interface Lists extends PropName {
    pageNum: number,
}

export interface newsLists extends Lists {
    pageSize?: number
}

export interface bannerProps extends PropName {
    location: number
}

export interface CoursesVisibleProps extends Lists {

}

export interface ActivitiesVisible extends Lists {
    status?: number
}

export interface ActivitiesDetail extends PropName {
    activityId: string
}

export interface NewsDetail extends PropName {
    id: string
}

export interface CoursesChapters extends PropName {
    courseId: string,
    userId?: string
}

export interface SystemsCaptcha extends PropName {
    uuid: string
}

export interface SystemsCaptchaSms extends PropName {
    captcha: string,
    mobile: string
}

export async function getBanner(payload: bannerProps) {
    // 获取首页轮播
    return Request(`${base}/banners/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getIntroduction() {
    // 获取关于我们详情
    return Request(`${base}/commons/introduction`, {
        method: 'GET'
    })
}

export async function getCoursesPopular() {
    // 获取热门课程
    return Request(`${base}/courses/popular`, {
        method: 'GET'
    })
}

export async function getCoursesCategory() {
    // 获取课程类别
    return Request(`${base}/courses/categories`, {
        method: 'GET'
    })
}

export async function getCoursesVisible(payload: CoursesVisibleProps) {
    // 分页查询获取课程列表
    return Request(`${base}/courses/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getCoursesChapters(payload: CoursesChapters) {
    // 查询课程章节
    return Request(`${base}/courses/${payload.courseId}/chapters`, {
        method: 'GET'
    })
}

interface ChapterDetailProps extends PropName {
    chapterId: string,
    userId?: string
}

export async function getChapterDetail(payload: ChapterDetailProps) {
    // 查询课程章节详情
    return Request(`${base}/chapters/${payload.chapterId}/detail?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getCoursesSummary(payload: CoursesChapters) {
    // 查询课程概要
    return Request(`${base}/courses/${payload.courseId}/summary?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getCoursesTeachers(payload: CoursesChapters) {
    // 查询课程讲师
    return Request(`${base}/courses/${payload.courseId}/teachers`, {
        method: 'GET'
    })
}

export async function getEnterprisesServices() {
    // 获取企业服务
    return Request(`${base}/enterprises/services`, {
        method: 'GET'
    })
}
export async function getCompanyInfo() {
    // 获取企业滚动信息
    return Request(`${base}/enterprises/queryCompanyInfo`, {
        method: 'GET'
    })
}
export async function queryCustomerInfo() {
    // 获取个人滚动信息
    return Request(`${base}/authorities/queryCustomerInfo`, {
        method: 'GET'
    })
}
export async function selectHomeRollInfo() {
    // 首页滚动信息
    return Request(`${base}/authorities/homeRollInfo`, {
        method: 'GET'
    })
}
export async function getConditionList(payload: { key: string }) {
    // 企业认证查询
    return Request(`${base}/enterprises/conditionList?${stringify(payload)}`, {
        method: 'GET'
    })
}
export async function queryMaterialInfo(payload: { key: string }) {
    // 相关资料下载查询
    return Request(`${base}/enterprises/queryMaterialInfo?${stringify(payload)}`, {
        method: 'GET'
    })
}
export async function getActivitiesPopular() {
    // 获取线下热门活动
    return Request(`${base}/activities/popular`, {
        method: 'GET'
    })
}

export async function getActivitiesVisible(payload: ActivitiesVisible) {
    // 分页获取线下活动列表
    return Request(`${base}/activities/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}


export async function getActivitiesDetail(payload: ActivitiesDetail) {
    // 获取线下活动详情
    return Request(`${base}/activities/${payload.activityId}/detail`, {
        method: 'GET'
    })
}

export async function getTrainingsPopular() {
    // 获取线下热门培训
    return Request(`${base}/trainings/popular`, {
        method: 'GET'
    })
}

export async function getTrainingsVisible(payload: ActivitiesVisible) {
    // 分页获取线下培训列表
    return Request(`${base}/trainings/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}


export async function getTrainingsDetail(payload: ActivitiesDetail) {
    // 获取线下活动详情
    return Request(`${base}/trainings/${payload.activityId}/detail`, {
        method: 'GET'
    })
}

export async function getNewsVisible(payload: Lists) {
    // 分页获取新闻列表
    return Request(`${base}/news/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getNewsDetail(payload: NewsDetail) {
    // 获取新闻详情
    return Request(`${base}/news/${payload.id}/detail`, {
        method: 'GET'
    })
}

export async function getPartners() {
    // 获取合作伙伴列表
    return Request(`${base}/partners/visible`, {
        method: 'GET'
    })
}

export async function getBlogsLists(payload: Lists) {
    // 分页获取管家生活列表
    return Request(`${base}/blogs/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}


export async function getSystemsCaptchaJpg(payload: SystemsCaptcha) {
    // 获取图片验证码
    return Request(`${base}/systems/captcha.jpg?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getSystemsCaptchaSms(payload: SystemsCaptchaSms) {
    // 获取短信验证码
    return Request(`${base}/systems/captcha.sms?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function SystemsLoginSms(payload: SystemsCaptchaSms) {
    // 手机号码登录
    return Request(`${base}/systems/login.sms?${stringify(payload)}`, {
        method: 'POST'
    })
}

export interface UserInfoParams extends PropName {
    userId: string
}

export async function getUserInfo(payload: UserInfoParams) {
    // 查询用户信息
    return Request(`${base}/users/${payload.userId}/info`, {
        method: 'GET'
    })
}

export interface setUserNickNameParams extends UserInfoParams {
    nickname: string
}

export async function setUserNickName(payload: setUserNickNameParams) {
    // 修改用户昵称
    return Request(`${base}/users/${payload.userId}/nickname?nickname=${payload.nickname}`, {
        method: 'POST'
    })
}

export interface setUserSkillParams extends UserInfoParams {
    skill: string
}

export async function setUserSkill(payload: setUserSkillParams) {
    // 修改用户简历技能
    return Request(`${base}/users/${payload.userId}/skill?skill=${payload.skill}`, {
        method: 'POST'
    })
}

export async function setUserMobile(payload: setUserNickNameParams) {
    // 修改用户昵称
    return Request(`${base}/users/${payload.userId}/mobile?mobile=${payload.nickname}`, {
        method: 'POST'
    })
}

export interface UsersOrdersLists extends UserInfoParams, Lists {
    status?: number
}

export async function getUsersOrdersLists(payload: UsersOrdersLists) {
    // 分页查询用户订单
    return Request(`${base}/users/${payload.userId}/orders?${stringify(payload)}`, {
        method: 'GET'
    })
}

export interface UsersTrainingsLists extends UserInfoParams, Lists {
}

export async function getUsersTrainingsLists(payload: UsersTrainingsLists) {
    // 分页查询用户线下培训列表
    return Request(`${base}/users/${payload.userId}/trainings?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getRecruitsVisibleLists(payload: Lists) {
    // 分页查询招聘信息
    return Request(`${base}/recruits/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

type RecruitDetail = {
    recruitId: string
}

export async function getRecruitsVisibleDetail(payload: RecruitDetail) {
    // 分页查询招聘信息
    return Request(`${base}/recruits/${payload.recruitId}/detail`, {
        method: 'GET'
    })
}

export interface activitiesEnrollParams {
    userId: string,
    activityId: string,
}

export async function activitiesEnroll(payload: activitiesEnrollParams) {
    // 报名线下活动
    return Request(`${base}/activities/${payload.activityId}/enroll?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export interface trainingsEnrollParams {
    userId: string,
    trainingId: string,
}

export async function trainingsEnroll(payload: trainingsEnrollParams) {
    // 报名线下培训
    return Request(`${base}/trainings/${payload.trainingId}/enroll?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export interface OrdersSubmitParams extends PropName {
    userId: string,
    courseId: string
}

export async function ordersSubmit(payload: OrdersSubmitParams) {
    // 提交订单
    return Request(`${base}/orders/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getCommonIndex() {
    // 查询首页配置项
    return Request(`${base}/commons/images`, {
        method: 'GET'
    })
}

export async function getGradesLists() {
    // 查询会员等级列表
    return Request(`${base}/grades/visible`, {
        method: 'GET'
    })
}

export interface GradesInfo extends PropName {
    gradeId: string
}

export async function getGradesInfoById(payload: GradesInfo) {
    // 查询会员等级详情
    return Request(`${base}/grades/${payload.gradeId}/detail`, {
        method: 'GET'
    })
}

export async function forAuthentication() {
    // 查询认证会员详情
    return Request(`${base}/authorities/introduction`, {
        method: 'GET'
    })
}

interface AuthoritiesDetail extends UserInfoParams {
    authorityId: string
}

export async function getAuthoritiesDetail(payload: AuthoritiesDetail) {
    // 查询会员认证记录详情
    return Request(`${base}/authorities/${payload.authorityId}/detail?userId=${payload.userId}`, {
        method: 'GET'
    })
}

export async function postAuthoritiesSubmit(payload: UserInfoParams) {
    // 提交会员认证申请
    return Request(`${base}/authorities/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

export interface applyAuthenticationParams extends PropName {
    customerId: string
}

export async function applyAuthentication(payload: applyAuthenticationParams) {
    // 申请会员认证
    return Request(`${base}/grades/apply/authentication?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function ossSignature() {
    // 构建上传签名
    return Request(`${base}/oss/signature`, {
        method: 'POST'
    })
}

export interface ossUploadParams extends PropName {
    url: string,
    body: FormData
}

export async function ossUploadFile(payload: ossUploadParams) {
    // 上传文件
    return Request(payload.url, {
        method: 'POST',
        body: payload.body,
        credentials: 'omit'
    })
}

export interface setUsersAvatarParams extends PropName {
    userId: string,
    avatar: string
}

export async function setUsersAvatar(payload: setUsersAvatarParams) {
    // 修改用户头像
    return Request(`${base}/users/${payload.userId}/avatar?${stringify(payload)}`, {
        method: 'POST'
    })
}

export interface postFeedbackParams extends PropName {
    customerId: string,
    content: string
}

export async function postFeedback(payload: postFeedbackParams) {
    // 提交反馈意见
    return Request(`${base}/feedback/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getUserEducations(payload: UserInfoParams) {
    // 查询用户教育经历
    return Request(`${base}/users/${payload.userId}/educations`, {
        method: 'GET'
    })
}

export async function getUserWorks(payload: UserInfoParams) {
    // 查询用户教育经历
    return Request(`${base}/users/${payload.userId}/works`, {
        method: 'GET'
    })
}

interface WorksDetail extends UserInfoParams {
    workId: string
}

export async function getUserWorksDetail(payload: WorksDetail) {
    // 查询用户教育经历
    return Request(`${base}/works/${payload.workId}/detail?userId=${payload.userId}`, {
        method: 'GET'
    })
}

export interface UserSex extends UserInfoParams {
    sex: number
}

export async function postUserSex(payload: UserSex) {
    // 设置用户性别
    return Request(`${base}/users/${payload.userId}/sex?sex=${payload.sex}`, {
        method: 'POST'
    })
}

export interface UserBirthday extends UserInfoParams {
    birthday: string
}

export async function postUserBirthday(payload: UserBirthday) {
    // 设置用户生日
    return Request(`${base}/users/${payload.userId}/birthday?birthday=${payload.birthday}`, {
        method: 'POST'
    })
}

export async function getUserCertificates(payload: UserInfoParams & Lists) {
    // 查询用户证书列表
    return Request(`${base}/users/${payload.userId}/certificates?pageNum=${payload.pageNum}`, {
        method: 'GET'
    })
}

interface Status {
    status?: number
}

export async function getUserCoupons(payload: UserInfoParams & Lists & Status) {
    // 查询用户优惠券列表
    return Request(`${base}/users/${payload.userId}/coupons?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getUserCourses(payload: UserInfoParams & Lists & Status) {
    // 查询用户课程列表
    return Request(`${base}/users/${payload.userId}/courses?${stringify(payload)}`, {
        method: 'GET'
    })
}

interface UserName extends UserInfoParams {
    name: string
}

export async function postUserName(payload: UserName) {
    // 设置用户真实姓名
    return Request(`${base}/users/${payload.userId}/name?name=${payload.name}`, {
        method: 'POST'
    })
}

interface Identity extends UserInfoParams {
    identity: string
}

export async function postUserIdentity(payload: Identity) {
    // 设置用户身份证
    return Request(`${base}/users/${payload.userId}/identity?identity=${payload.identity}`, {
        method: 'POST'
    })
}

export async function postUserEducationSubmit(payload: EducationProps) {
    // 提交教育经历
    return Request(`${base}/educations/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}


export interface EducationDetailProps extends UserInfoParams {
    educationId: string
}

export async function getUserEducationById(payload: EducationDetailProps) {
    // 根据ID查询教育经历
    return Request(`${base}/educations/${payload.educationId}/detail?userId=${payload.userId}`, {
        method: 'GET'
    })
}

export async function postUserEducationModify(payload: EducationModifyProps) {
    // 修改教育经历
    return Request(`${base}/educations/${payload.educationId}/modify?${stringify(payload)}`, {
        method: 'POST'
    })
}

export interface WorksProps extends UserInfoParams {
    company: string,
    post: string,
    content: string,
    start: string,
    end: string
}

export async function postUserWorksSubmit(payload: WorksProps) {
    // 提交工作经历
    return Request(`${base}/works/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

interface WorksModify extends WorksProps {
    workId: string
}

export async function postUserWorksModify(payload: WorksModify) {
    // 提交工作经历
    return Request(`${base}/works/${payload.workId}/modify?${stringify(payload)}`, {
        method: 'POST'
    })
}

export interface UserNameProps extends UserInfoParams {
    name: string
}

export async function postUserNameModify(payload: UserNameProps) {
    // 修改用户真实姓名
    return Request(`${base}/users/${payload.userId}/name?name=${payload.name}`, {
        method: 'POST'
    })
}

export interface ResumePhotoProps extends UserInfoParams {
    photo: string
}

export async function postResumePhotoModify(payload: ResumePhotoProps) {
    // 修改用户简历照片
    return Request(`${base}/users/${payload.userId}/photo?photo=${payload.photo}`, {
        method: 'POST'
    })
}

export interface UserMobileModifyProps extends UserInfoParams {
    areaCode: string,
    captcha: string,
    current: string,
    original: string
}

export async function postUserMobileModify(payload: UserMobileModifyProps) {
    // 修改用户绑定手机
    return Request(`${base}/users/${payload.userId}/mobile?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getUserResumesInfo(payload: UserInfoParams) {
    // 查询用户在线简历
    return Request(`${base}/users/${payload.userId}/resumes`, {
        method: 'GET'
    })
}

interface ResumesVisible extends Lists {
    stars: string,
    regions: string,
    ages: string
}

export async function getResumesVisible(payload: ResumesVisible) {
    // 查询管家简历列表
    return Request(`${base}/resumes/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

type ResumesDetail = {
    resumeId: string
}

export async function postResumesDetail(payload: ResumesDetail) {
    // 查询管家简历详情
    return Request(`${base}/resumes/${payload.resumeId}/detail?${stringify(payload)}`, {
        method: 'POST'
    })
}

interface Region extends UserInfoParams {
    region: string
}

export async function postUserRegion(payload: Region) {
    // 修改用户所在地
    return Request(`${base}/users/${payload.userId}/region?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getTelecastsLists(payload: Lists) {
    // 分页查询直播预告
    return Request(`${base}/telecasts/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

export interface TelecastDetail extends PropName {
    telecastId: string
}

export async function getTelecastsDetail(payload: TelecastDetail) {
    // 查询直播预告详情
    return Request(`${base}/telecasts/${payload.telecastId}/detail`, {
        method: 'GET'
    })
}

export async function getUserActivities(payload: Lists & UserInfoParams) {
    // 分页查询用户线下活动
    return Request(`${base}/users/${payload.userId}/activities?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getCountriesLists(payload: Lists) {
    // 分页查询国家列表
    return Request(`${base}/countries/visible?pageNum=${payload.pageNum}`, {
        method: 'GET'
    })
}

export async function getUserRegisterGift() {
    // 查询新人礼
    return Request(`${base}/actions/register`, {
        method: 'GET'
    })
}

type WorksRemove = {
    userId: string,
    workId: string
}

type EducationRemove = {
    userId: string,
    educationId: string
}


export async function removeUserEducationById(payload: EducationRemove) {
    // 根据ID移除教育经历
    return Request(`${base}/educations/${payload.educationId}/remove?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export async function removeUserWorkById(payload: WorksRemove) {
    // 根据ID移除工作经历
    return Request(`${base}/works/${payload.workId}/remove?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export async function getCommonTelephones() {
    // 查询咨询电话配置
    return Request(`${base}/commons/telephones`, {
        method: 'GET'
    })
}

interface BlogLikeProps extends UserInfoParams {
    blogId: string
}

export async function postBlogLike(payload: BlogLikeProps) {
    // 点赞管家生活
    return Request(`${base}/blogs/${payload.blogId}/like?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export async function postBlogUnLike(payload: BlogLikeProps) {
    // 取消点赞管家生活
    return Request(`${base}/blogs/${payload.blogId}/unlike?userId=${payload.userId}`, {
        method: 'POST'
    })
}

export async function getStoriesLists(payload: Lists) {
    // 查询咨询电话配置
    return Request(`${base}/stories/visible?${stringify(payload)}`, {
        method: 'GET'
    })
}

interface OrdersAvailableProps extends Lists, UserInfoParams {
    orderId: string
}

export async function getOrdersAvailable(payload: OrdersAvailableProps) {
    // 分页查询可用优惠券
    return Request(`${base}/orders/${payload.orderId}/coupons?${stringify(payload)}`, {
        method: 'GET'
    })
}

type OrdersDetailProps = Omit<OrdersAvailableProps, "pageNum">

export async function getOrdersDetail(payload: OrdersDetailProps) {
    // 查询订单详情
    return Request(`${base}/orders/${payload.orderId}/detail?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function postOrdersCancel(payload: OrdersDetailProps) {
    // 取消订单
    return Request(`${base}/orders/${payload.orderId}/cancel?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function postOrdersSubmit(payload: OrdersDetailProps & CoursesChapters) {
    // 提交订单
    return Request(`${base}/orders/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

interface TradesPayment extends UserInfoParams {
    tradeId: string
}

export async function postTradesPayment(payload: TradesPayment) {
    // 线下支付交易账单
    return Request(`${base}/trades/${payload.tradeId}/payment?userId=${payload.userId}`, {
        method: 'POST'
    })
}

interface TradesSubmit extends UserInfoParams {
    orderId: string,
    couponId?: string
}

export async function postTradesSubmit(payload: TradesSubmit) {
    // 提交交易账单
    return Request(`${base}/trades/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getTradesResult(payload: TradesPayment) {
    // 查询交易结果
    return Request(`${base}/trades/${payload.tradeId}/result?userId=${payload.userId}`, {
        method: 'GET'
    })
}

export async function getAgreements() {
    // 查询交易结果
    return Request(`${base}/agreements/detail`, {
        method: 'GET'
    })
}

export async function getDistributions() {
    // 查询分销详情
    return Request(`${base}/distributions/detail`, {
        method: 'GET'
    })
}

export async function postDistributionsSubmit(payload: applyAuthenticationParams) {
    // 查询分销详情
    return Request(`${base}/distributions/submit?${stringify(payload)}`, {
        method: 'POST'
    })
}

export async function getGiftsExChange(payload: { userId: string, code: string }) {
    // 兑换码兑换优惠券
    return Request(`${base}/gifts/exchange?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getAdsAvailable(payload:{ userId?:string }){
    // 查询开屏广告
    return Request(`${base}/ads/available?${stringify(payload)}`, {
        method: 'GET'
    })
}

export async function getAdsVisit(payload:{ userId:string,adId:string }){
    // 客户访问开屏广告
    return Request(`${base}/ads/${payload.adId}/visit?userId=${payload.userId}`, {
        method: 'GET'
    })
}

export async function getSubtitles(){
    // 查询发现页子标题配置
    return Request(`${base}/commons/subtitles`, {
        method: 'GET'
    })
}

export async function getDistributionIntroduction(){
    // 查询课程分销介绍
    return Request(`${base}/distributions/introduction`, {
        method: 'GET'
    })
}

export async function postDistributionApply(payload:applyAuthenticationParams){
    // 提交课程分销申请
    return Request(`${base}/distributions/apply?${ stringify(payload) }`, {
        method: 'POST'
    })
}

interface postDistributionRecommendProps extends applyAuthenticationParams{
    name:string,
    phone:string,
    industry:string,
    category:number
}

export async function postDistributionRecommend(payload:postDistributionRecommendProps){
    // 提交推荐学员信息
    return Request(`${base}/distributions/recommend?${ stringify(payload) }`, {
        method: 'POST'
    })
}



export async function getDistributionRecommendations(payload:newsLists & applyAuthenticationParams){
    // 分页查询课程分销推荐记录列表
    return Request(`${base}/distributions/recommendations?${ stringify(payload) }`, {
        method: 'GET'
    })
}

interface DistributionFollows extends newsLists{
    recordId:string
}

export async function getDistributionFollows(payload:DistributionFollows){
    // 分页查询课程分销推荐记录列表
    return Request(`${base}/distributions/follows?${ stringify(payload) }`, {
        method: 'GET'
    })
}
